export default "__VITE_ASSET__c7af54cb__"